module.exports = __webpack_public_path__ + "img/nms-demo5.b803cb15.png";